export type SupportPartnerType = 'technical_assistance' | 'financial' | 'veterinary' | 'certification' | 'research' | 'cooperative' | 'marketplace';

export type SupportServiceType = 
  | 'melhoramento_genetico' 
  | 'credito_rural' 
  | 'assistencia_veterinaria' 
  | 'certificacao_organica' 
  | 'analise_solo' 
  | 'treinamento_tecnico' 
  | 'comercializacao' 
  | 'pesquisa_desenvolvimento';

export interface SupportPartner {
  id: string;
  name: string;
  type: SupportPartnerType;
  description: string;
  logo?: string;
  website?: string;
  phone?: string;
  email?: string;
  services: SupportServiceType[];
  regions: string[]; // Brazilian states they serve
  isVerified: boolean;
  rating?: number;
  responseTime?: string; // e.g., "2-4 horas"
  createdAt: string;
  isActive: boolean;
}

export interface SupportPartnerSearchResult {
  partner: SupportPartner;
  matchScore: number;
  matchReason: string;
}

export interface SupportPartnerFilters {
  type?: SupportPartnerType;
  service?: SupportServiceType;
  region?: string;
  verified?: boolean;
}

export const supportServiceLabels: Record<SupportServiceType, string> = {
  melhoramento_genetico: 'Melhoramento Genético',
  credito_rural: 'Crédito Rural',
  assistencia_veterinaria: 'Assistência Veterinária',
  certificacao_organica: 'Certificação Orgânica',
  analise_solo: 'Análise de Solo',
  treinamento_tecnico: 'Treinamento Técnico',
  comercializacao: 'Comercialização',
  pesquisa_desenvolvimento: 'Pesquisa e Desenvolvimento',
};

export const supportPartnerTypeLabels: Record<SupportPartnerType, string> = {
  technical_assistance: 'Assistência Técnica',
  financial: 'Financeiro',
  veterinary: 'Veterinário',
  certification: 'Certificação',
  research: 'Pesquisa',
  cooperative: 'Cooperativa',
  marketplace: 'Marketplace',
};

export const brazilianStates = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 
  'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 
  'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
];

export const brazilianStateLabels: Record<string, string> = {
  'AC': 'Acre', 'AL': 'Alagoas', 'AP': 'Amapá', 'AM': 'Amazonas',
  'BA': 'Bahia', 'CE': 'Ceará', 'DF': 'Distrito Federal', 'ES': 'Espírito Santo',
  'GO': 'Goiás', 'MA': 'Maranhão', 'MT': 'Mato Grosso', 'MS': 'Mato Grosso do Sul',
  'MG': 'Minas Gerais', 'PA': 'Pará', 'PB': 'Paraíba', 'PR': 'Paraná',
  'PE': 'Pernambuco', 'PI': 'Piauí', 'RJ': 'Rio de Janeiro', 'RN': 'Rio Grande do Norte',
  'RS': 'Rio Grande do Sul', 'RO': 'Rondônia', 'RR': 'Roraima', 'SC': 'Santa Catarina',
  'SP': 'São Paulo', 'SE': 'Sergipe', 'TO': 'Tocantins'
}; 